/**
 * Stories implemented for this component
 */
/* eslint-disable local-rules/require-storybook-documentation */
import { FC } from 'react';
import dynamic from 'next/dynamic';
import { TeamInformationCardVariant } from './types';
import type { AssignedTeamMembersProps } from './types';

const TeamAssignedVariant = dynamic(() =>
    import(
        /* webpackChunkName: "TeamAssignedVariant" */
        './variants/TeamAssignedVariant'
    ).then(mod => mod.TeamAssignedVariant)
);

const NoTeamVariant = dynamic(() =>
    import(
        /* webpackChunkName: "NoTeamVariant" */
        './variants/NoTeamVariant'
    ).then(mod => mod.NoTeamVariant)
);

export const AssignedTeamMembers: FC<AssignedTeamMembersProps> = props => {
    switch (props.variant) {
        case TeamInformationCardVariant.TEAM_ASSIGNED:
            return <TeamAssignedVariant {...props} />;
        case TeamInformationCardVariant.NO_TEAM:
            return <NoTeamVariant {...props} />;
        default:
            return null;
    }
};
